// src/components/Home/ImpactStats.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { ImpactStats as ImpactStatsType } from '../../types';

interface Props {
  data: ImpactStatsType | null;
}

const ImpactStats: React.FC<Props> = ({ data }) => {
  const stats = [
    {
      icon: '🌱',
      value: data?.trees_planted || 10000,
      label: 'Trees Planted',
      suffix: '+'
    },
    {
      icon: '👩‍🌾',
      value: data?.women_empowered || 2000,
      label: 'Women Empowered',
      suffix: '+'
    },
    {
      icon: '👥',
      value: data?.volunteers_count || 10,
      label: 'Volunteers',
      suffix: '+'
    },
    {
      icon: '🏘️',
      value: data?.communities_reached || 10,
      label: 'Communities Reached',
      suffix: '+'
    }
  ];

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <div className="row text-center">
          <div className="col-12 mb-5">
            <h2 className="display-5 fw-bold text-success">Our Impact</h2>
            <p className="lead">Making a difference across African communities</p>
          </div>
        </div>
        
        <div className="row">
          {stats.map((stat, index) => (
            <motion.div 
              key={stat.label}
              className="col-md-3 col-6 mb-4"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="text-center">
                <div className="display-4 text-success mb-2">{stat.icon}</div>
                <h3 className="fw-bold text-dark">
                  {stat.value.toLocaleString()}{stat.suffix}
                </h3>
                <p className="text-muted">{stat.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactStats;